import React, { useState, useLayoutEffect } from 'react';
import cx from 'classnames';
import useScrollPosition from '../hooks/useScrollPosition';
import canUseDom from '../../util/canUseDOM';
import metrics from '../../browser/metrics';
import CommentBox from './CommentBox';
import feedbackModes from '../FeedbackSection/feedbackModes.json';
import BooleanFeedback from '../FeedbackSection/BooleanFeedback';

import styles from './styles.module.styl';

/* eslint-disable jsx-a11y/no-static-element-interactions */
const FeedbackWidget = () => {
  const [widgetVisible, setWidgetVisible] = useState(true);
  const [vote, setVote] = useState('none');
  const [done, setDone] = useState(null);
  const [footer, setFooter] = useState(null);
  const scrollPos = useScrollPosition();

  useLayoutEffect(() => {
    setFooter($('.article-footer'));
  }, []);

  if (!canUseDom()) { return <></>; }
  if (done) { return <></>; }

  const submitVote = (v) => { setVote(v); metrics.track('feedback:submit', { value: v === 'positive' }); };
  const dismissWidget = () => { setWidgetVisible(false); if (!vote) { metrics.track('feedback:dismiss'); } };
  const submitComment = (comment) => {
    setDone(true);
    metrics.track('feedback:submit-comment', { value: vote === 'positive', trackData: comment });

    $.post('/docs/submit-feedback', {
      page_title: document.title,
      page_url: window.location.href,
      positive: vote === 'positive',
      comment
    });
  };

  let footerVisible;
  if (footer && footer[0]) {
    const footerPos = (footer.offset().top + footer.height()) - window.innerHeight;
    footerVisible = scrollPos.y >= footerPos;
  }

  return (
    <div
      className={cx(
        vote !== 'none' ? styles.feedbackSent : '',
        widgetVisible ? styles.visible : styles.hidden,
        styles.sidebar,
        footerVisible ? styles.hideSidebar : styles.showSidebar
      )}
    >
      <a className={styles.closeButton} onClick={dismissWidget}><i className="icon-budicon-471" /></a>

      <h5>{vote !== 'none' ? 'Thanks for the feedback!' : 'Is this article helpful?'}</h5>
      {vote === 'none' && <BooleanFeedback
        text="Yes"
        feedbackMode={feedbackModes.POSITIVE}
        currentFeedbackMode={feedbackModes[vote.toUpperCase()]}
        handleClick={() => submitVote('positive')}
        useButtons
      />}
      {vote === 'none' && <BooleanFeedback
        text="No"
        feedbackMode={feedbackModes.NEGATIVE}
        currentFeedbackMode={feedbackModes[vote.toUpperCase()]}
        handleClick={() => submitVote('negative')}
        useButtons
      />}
      {vote !== 'none' && <CommentBox vote={vote} submit={submitComment} />}
    </div>
  );
};

export default FeedbackWidget;
